"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurHeritageHospitality() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="221902" id="built-on-trust" ref={sectionRef} className="relative w-full bg-background py-24 lg:py-32 overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          
          {}
          <div className={`lg:col-span-6 relative h-[500px] sm:h-[600px] w-full transition-all duration-1000 ease-out ${isSectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            {}
            <div className="absolute top-0 right-0 lg:-right-12 w-[85%] h-[70%] z-20 rounded-lg overflow-hidden shadow-2xl border border-primary/10">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645726/img/rm_founding_team_site.png" alt="RM Roofing founding team on a construction site" className="w-full h-full object-cover grayscale-[20%] hover:grayscale-0 transition-all duration-700" />
            </div>
            
            {}
            <div className="absolute bottom-0 left-0 w-[65%] h-[60%] z-30 rounded-lg overflow-hidden shadow-xl border-8 border-background">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645726/img/roofing_technical_precision.png" alt="Close up of high-quality roofing installation" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
            </div>
          </div>

          {}
          <div ref={textRef} className={`lg:col-span-6 relative z-10 lg:pl-16 transition-all duration-1000 delay-300 ease-out ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            {}
            <h2 className="font-default text-5xl sm:text-6xl lg:text-7xl font-extrabold text-foreground leading-tight tracking-tighter mb-8 relative z-0">
              The RM <br className="hidden sm:block" /> Manifesto
            </h2>
            
            <div className="space-y-6 text-lg text-muted-foreground leading-relaxed max-w-prose">
              <div className="border-t-2 border-primary/20 pt-6">
                <p className="font-default font-semibold text-foreground mb-2 flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-ring"></span> Integrity Above All
                </p>
                <p className="font-default">
                  RM Roofing & Waterproofing was founded on a simple principle: impenetrable protection. We don't just install roofs; we engineer structural shields for residential and industrial assets.
                </p>
              </div>
              
              <div className="border-t-2 border-primary/20 pt-6">
                <p className="font-default font-semibold text-foreground mb-2 flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-ring"></span> Proven Timeline
                </p>
                <p className="font-default">
                  Our skilled team is committed to delivering top-tier craftsmanship and attention to detail, ensuring every project meets the highest industry standards and is completed on time and within budget.
                </p>
              </div>
            </div>

            
          </div>

        </div>
      </div>
    </section>;
}